import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";

// Inject global overrides for Toastify once
let styleInjected = false;
function injectStyles() {
    if (styleInjected) return;
    styleInjected = true;
    const style = document.createElement("style");
    style.textContent = `
        .toastify.nc-toast-wrapper {
            padding: 0 !important;
            background: none !important;
            box-shadow: none !important;
            max-width: min(420px, calc(100vw - 32px)) !important;
            min-width: 0 !important;
            cursor: default !important;
        }
    `;
    document.head.appendChild(style);
}

const icons = {
    primary: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>`,
    success: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>`,
    error: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>`,
    info: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>`,
    warning: `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>`,
};

const themes = {
    primary: {
        bg: "#f0f4f8",
        border: "#cbd5e1",
        text: "#334155",
        icon: "#64748b",
    },
    success: {
        bg: "#f0fdf4",
        border: "#86efac",
        text: "#166534",
        icon: "#22c55e",
    },
    error: {
        bg: "#fef2f2",
        border: "#fca5a5",
        text: "#991b1b",
        icon: "#ef4444",
    },
    info: {
        bg: "#eff6ff",
        border: "#93c5fd",
        text: "#1e40af",
        icon: "#3b82f6",
    },
    warning: {
        bg: "#fffbeb",
        border: "#fcd34d",
        text: "#92400e",
        icon: "#f59e0b",
    },
};

function createToast(type, message, duration = 3000) {
    injectStyles();

    const theme = themes[type];
    const icon = icons[type];

    const node = document.createElement("div");
    node.style.cssText = `
        display: flex;
        align-items: center;
        gap: 10px;
        background: ${theme.bg};
        border: 1px solid ${theme.border};
        border-radius: 10px;
        padding: 10px 12px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.08), 0 1px 3px rgba(0,0,0,0.06);
        color: ${theme.text};
        font-size: 14px;
        font-weight: 500;
        line-height: 1.4;
    `;
    const iconSpan = document.createElement('span');
    iconSpan.style.cssText = `flex-shrink:0;display:flex;align-items:center;color:${theme.icon}`;
    iconSpan.innerHTML = icon; // SVG icon markup (not user-supplied)

    const msgSpan = document.createElement('span');
    msgSpan.style.cssText = 'flex:1;min-width:0';
    msgSpan.textContent = message; // Safe: textContent prevents XSS

    const closeBtn = document.createElement('button');
    closeBtn.style.cssText = `flex-shrink:0;display:flex;align-items:center;justify-content:center;width:22px;height:22px;border:none;background:transparent;color:${theme.text};opacity:0.4;cursor:pointer;border-radius:4px;padding:0;-webkit-tap-highlight-color:transparent`;
    closeBtn.setAttribute('aria-label', 'Sluiten');
    closeBtn.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';

    node.appendChild(iconSpan);
    node.appendChild(msgSpan);
    node.appendChild(closeBtn);

    const toast = Toastify({
        node: node,
        duration: duration,
        gravity: "top",
        position: "center",
        offset: { y: 60 },
        close: false,
        className: "nc-toast-wrapper",
    });

    toast.showToast();

    // Wire close button
    if (closeBtn) {
        closeBtn.addEventListener("click", (e) => {
            e.stopPropagation();
            toast.hideToast();
        });
    }
}

export default {
    primary(message, duration = 3000) {
        createToast("primary", message, duration);
    },
    success(message, duration = 3000) {
        createToast("success", message, duration);
    },
    error(message, duration = 3000) {
        createToast("error", message, duration);
    },
    info(message, duration = 3000) {
        createToast("info", message, duration);
    },
    warning(message, duration = 3000) {
        createToast("warning", message, duration);
    },
};
